import { SpaceType } from 'data/types';

export function spaceSaveBTUs(btus: SpaceType['BTUs'] | undefined): {
  heating: number;
  cooling: number;
  latent?: number | null;
} {
  if (
    btus &&
    typeof btus.heating === 'number' &&
    typeof btus.cooling === 'number'
  ) {
    return btus;
  }
  return { heating: 0, cooling: 0 };
}

export function spaceSaveAirHandlerRankings(
  rankings: SpaceType['airHandlerRankings'] | undefined
): SpaceType['airHandlerRankings'] {
  return rankings ?? [];
}
